import { PinkButton, TransparentButton, WhiteButton } from 'core/buttons/buttons';
import { useEffect, useState } from 'react';

import { getUserInfo } from 'api/api';
import PropTypes from 'prop-types';
import { useTranslations } from 'next-intl';

const MyAcountButton = ({ buttonType = 'home' }) => {
    const t = useTranslations('header.keypad');
    const [userName, setUserName] = useState();

    useEffect(async () => {
        await getUserInfo()
            .then((data) => setUserName(data.ua_first_name.toUpperCase()))
            // eslint-disable-next-line no-console
            .catch((_error) => {});
    }, []);

    if (buttonType === 'home') {
        return <TransparentButton
            label={userName || t('my-account.text')}
            compact
            href={t('my-account.link')}
        />;
    } else if (buttonType === 'new-home') {
        return <WhiteButton
            label={userName || t('my-account.text')}
            href={t('my-account.link')}
            compact
        />;
    };
    return <PinkButton
        label={userName || t('my-account.text')}
        compact
        href={t('my-account.link')}
    />;
};

MyAcountButton.propTypes = {
    buttonType: PropTypes.string
};

export default MyAcountButton;
